/**
 * Der eine Satz, der von einem Eintrag im Änderungsbuch übrig bleibt (7.84).
 *
 * Die App zeigt unter *Was ist neu* je Eintrag eine Überschrift und einen
 * Satz. Bis hierher rechnete der Browser diesen Satz aus dem ganzen Text aus
 * -- und dafür musste der ganze Text zu jedem angemeldeten Menschen
 * geschickt werden. Für Einträge mit `### Dahinter` war das seit dem
 * 14. September geregelt; die zweihundert älteren hatten die Trennung nicht,
 * und deren Begründungen gingen weiter an alle.
 *
 * Also wird der Satz dort gerechnet, wo entschieden wird, wer was bekommt:
 * auf dem Server. Die Regel steht hier, damit beide Seiten dieselbe kennen
 * und sie geprüft ist.
 */
/**
 * Die Kurzfassung eines Eintrags: der erste **fett gesetzte Absatzanfang**,
 * sonst der erste Absatz -- und davon der erste Satz.
 */
export function kernsatz(body) {
    // Nur ein fett gesetzter Absatz*anfang* zählt. Ein fettes Wort mitten im
    // Text ist eine Betonung und keine Ankündigung -- daraus wurde sonst
    // „Look“ als Nachricht des Tages.
    const angekuendigt = /(?:^|\n[ \t]*\n)[ \t]*\*\*([^*]{20,})\*\*/.exec(body);
    const absatz = body.split(/\n\s*\n/).find((a) => a.trim().length > 0) ?? '';
    return satzAus(angekuendigt?.[1] ?? absatz);
}
/** Ein Satz daraus, ohne Auszeichnung, und nicht länger als eine Zeile oder zwei. */
function satzAus(roh) {
    const sauber = roh.replace(/\s+/g, ' ').replace(/[*`_]/g, '').trim();
    if (!sauber)
        return '';
    const punkt = sauber.search(/[.!?](\s|$)/);
    const satz = punkt > 0 ? sauber.slice(0, punkt + 1) : sauber;
    // Ein Halbsatz sagt weniger als gar nichts. Dann lieber die Überschrift
    // allein stehen lassen.
    if (satz.length < 20)
        return '';
    return satz.length > 160 ? `${satz.slice(0, 159).trimEnd()}…` : satz;
}
/** `### Neu` und `### Fixes`, als Listen. Alles andere bleibt liegen. */
export function punkteAus(body) {
    const raus = { neu: [], fixes: [] };
    let wohin = null;
    // Ein eingerahmtes Beispiel ist kein Inhalt: im Kopf der Datei steht, wie
    // eine Ausgabe auszusehen hat, und ohne diese Zeile stünden deren erfundene
    // Punkte in der App.
    let imRahmen = false;
    for (const zeile of body.split('\n')) {
        if (/^```/.test(zeile.trim())) {
            imRahmen = !imRahmen;
            continue;
        }
        if (imRahmen)
            continue;
        const ueberschrift = /^###\s+(.+?)\s*$/.exec(zeile);
        if (ueberschrift) {
            const name = ueberschrift[1].toLowerCase();
            wohin = name === 'neu' ? 'neu' : name === 'fixes' ? 'fixes' : null;
            continue;
        }
        if (!wohin)
            continue;
        const punkt = /^[-*]\s+(.+?)\s*$/.exec(zeile);
        // Eine Zeile ohne Strich beendet die Liste nicht -- eine leere schon gar
        // nicht. Was dazwischen steht, gehört aber auch nicht in die Liste.
        if (punkt)
            raus[wohin].push(punkt[1].replace(/[*`]/g, '').trim());
    }
    return raus;
}
//# sourceMappingURL=changelog.js.map